import React from 'react'

// type
import { GlobalComponentsContextType } from './types'

export const GlobalComponentsContext = React.createContext<GlobalComponentsContextType>({
	showToast: () => {},
})

interface PropsType {
	onShowToast: (message: string) => void
	children: JSX.Element
}

export const GlobalComponentsContextProvider = (props: PropsType) => {
	const globalComponentsContext: GlobalComponentsContextType = React.useMemo(
		() => ({
			showToast: (message: string) => {
				props.onShowToast(message)
			},
		}),
		[props],
	)

	return (
		<GlobalComponentsContext.Provider value={globalComponentsContext}>
			{props.children}
		</GlobalComponentsContext.Provider>
	)
}
